import * as React from 'react';
import { useGlobalState } from 'piral-core';
import { PiralSearchContainer, PiralSearchResult } from './components';
export const Search = () => {
    const { loading, items } = useGlobalState((m) => m.search.results);
    return (React.createElement(PiralSearchContainer, { loading: loading }, items.map((item, i) => (React.createElement(PiralSearchResult, { key: i }, item)))));
};
//# sourceMappingURL=Search.js.map